export default __webpack_public_path__ + "static/media/404_wide.813a6631.png";